var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgQuotation(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 164,
    height: 143,
    viewBox: "0 0 164 143",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M64.3465 1.61768V0.951493L63.7068 1.13758C45.4566 6.44674 30.8298 15.0826 19.8513 27.0591L19.8487 27.062C7.53925 40.7022 1.37695 56.5198 1.37695 74.4938V141.421V141.921H1.87695H63.8465H64.3465V141.421V74.4938V73.9938H63.8465H34.107C34.1808 63.0565 36.6826 54.0328 41.5781 46.8902C46.5464 39.6413 54.0099 34.2867 64.0092 30.8443L64.3465 30.7282V30.3715V1.61768ZM163.002 1.61768V0.951493L162.362 1.13758C144.112 6.44674 129.485 15.0826 118.507 27.0591L118.504 27.062C106.195 40.7022 100.032 56.5198 100.032 74.4938V141.421V141.921H100.532H162.502H163.002V141.421V74.4938V73.9938H162.502H132.763C132.836 63.0565 135.338 54.0328 140.234 46.8902C145.202 39.6413 152.665 34.2867 162.665 30.8443L163.002 30.7282V30.3715V1.61768Z",
    stroke: "#722D8E"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgQuotation);
export default __webpack_public_path__ + "static/media/quotation.9879f3cfadeaf4614a38fb4b3bc56451.svg";
export { ForwardRef as ReactComponent };